<template>
  <BaseButton type="cta" @click="onCopy" size="sm" class="copy-link-button">
    <BaseSvgIcon :name="isMobile ? 'copy' : 'link'" class="icon" />
    {{ isMobile ? $t("Copy") : $t("CopyLink") }}
  </BaseButton>
</template>

<script setup>
import { getCurrentInstance } from "vue";
import { BaseButton } from "@/shared/ui";
import { BaseSvgIcon } from "@/shared/ui/BaseSvgIcon";
import { copyToClipboard } from "@emcd/common/helpers";
import { useI18n } from "vue-i18n";
import { useBreakpoints } from "@/shared/utils/ui/useBreakpoints";
import "@/assets/icons/SVG/link.svg";

const { proxy } = getCurrentInstance();
const { t } = useI18n();
const { isMobile } = useBreakpoints();

const onCopy = () => {
  copyToClipboard(window.location.href, () => {});
  proxy.$toast({
    type: "success",
    title: t("LinkCopied"),
  });
  window.emcd.AnalyticsService.track("click", {
    event_type: "click",
    product: "explorer",
    screen: window.location.href.includes("transaction")
      ? "transaction"
      : "address",
    button_name: "copy_link",
  });
};
</script>

<style lang="scss" scoped>
.copy-link-button {
  height: 36px;
  display: flex;
  align-items: flex-end;
  padding: 10px 18px 10px 10px;
  gap: 8px;
  font-weight: 500;
  border-radius: 10px;
  line-height: 13px;
}
.icon {
  width: 16px;
  height: 16px;
}
</style>
